module.exports = __webpack_public_path__ + "static/home1-top-categories-767f4dc10017023d887a5daa98e659fe.jpg";